import { useContext } from 'react';

import { WorkflowPermissionContext } from '../../contexts/WorkflowPermissionContext';

export const useWorkflowPermissionContext = () =>
  useContext(WorkflowPermissionContext);
